
  
document.addEventListener('DOMContentLoaded', function() {

  setTimeout(function() {

    console.log('zzz');
    
    const bundlyComponents = document.querySelectorAll('.bundly__component');
    
    // Create the overlay
    const overlay = document.createElement('div');
    overlay.classList.add('overlay');
    document.body.appendChild(overlay);

    if (bundlyComponents.length === 0) {
      console.error('No Bundly components found.');
    }

    bundlyComponents.forEach((component, index) => {
      console.log(`Processing Bundly component ${index}`);

      // Create a sidebar for each variant component
      const variantSidebar = document.createElement('div');
      variantSidebar.classList.add('variant-sidebar');
      variantSidebar.setAttribute('id', `variantSidebar-${index}`);

      // Create the content container for the sidebar
      const sidebarContent = document.createElement('div');
      sidebarContent.classList.add('sidebar-content');
      variantSidebar.appendChild(sidebarContent);

      // Get the product URL from the anchor (without the variant query parameter)
      const productAnchor = component.querySelector('a');
      let productUrl = productAnchor ? productAnchor.getAttribute('href') : '';
      if (productUrl.includes('?variant=')) {
        productUrl = productUrl.split('?')[0]; // Remove the variant query parameter to get the base product URL
      }

      // Fetch product data from the JSON endpoint
      fetch(`${productUrl}.json`)
        .then(response => response.json())
        .then(data => {
          const productTitle = data.product.title;
          const productDescription = data.product.body_html;
          const variantData = data.product.variants;

          // Add product title
          const productTitleDiv = document.createElement('div');
          productTitleDiv.classList.add('product-title');
          productTitleDiv.innerHTML = `<h3>${productTitle}</h3>`;
          sidebarContent.appendChild(productTitleDiv);

          // Add product description
          const descriptionDiv = document.createElement('div');
          descriptionDiv.classList.add('product-description');
          descriptionDiv.innerHTML = productDescription;
          sidebarContent.appendChild(descriptionDiv);

          // Create custom radio buttons for variants
          const customRadioContainer = document.createElement('div');
          customRadioContainer.classList.add('custom-radio-container');

          variantData.forEach(variant => {
            const customRadio = document.createElement('div');
            customRadio.classList.add('custom-radio');
            customRadio.setAttribute('id', variant.title);
            customRadio.setAttribute('data-value', variant.title);

            // Create the actual radio button input
            const radioInput = document.createElement('input');
            radioInput.type = 'radio';
            radioInput.name = `variant-${index}`;
            radioInput.value = variant.title;

            // Get the image for the variant
            const variantImage = data.product.images.find(img => img.variant_ids.includes(variant.id));
            const imageElement = document.createElement('img');
            if (variantImage) {
              imageElement.src = variantImage.src;
            }
            imageElement.style.width = '50px';
            imageElement.style.marginRight = '10px';

            // Add the image to the radio button
            customRadio.appendChild(radioInput);
            customRadio.appendChild(imageElement);
            customRadio.appendChild(document.createTextNode(variant.title));

            // Add price for the variant
            const variantPrice = document.createElement('div');
            variantPrice.classList.add('variant-price');
            variantPrice.innerHTML = `<span> $${parseFloat(variant.price).toFixed(2)}</span>`; // Format the price
            customRadio.appendChild(variantPrice);

            customRadioContainer.appendChild(customRadio);

            // Add specs for the variant
            var variationspecs_content = document.querySelector(`[data-variation-title="${variant.title}"]`).innerHTML;
            const variantSpecs_con = document.createElement('div');
            variantSpecs_con.classList.add('variant-specs');
            variantSpecs_con.innerHTML = variationspecs_content;
            customRadio.appendChild(variantSpecs_con);
            
            // Add event listener for selecting a variant
            customRadio.addEventListener('click', () => {
              const variantValue = customRadio.getAttribute('data-value');

              // Find the corresponding main radio button and trigger click
              const correspondingMainRadio = component.querySelector(`.bundly__variant_radio[value="${variantValue}"]`);
              if (correspondingMainRadio) {
                correspondingMainRadio.click();  // Let the browser handle the checked state
              }

              // Update the sidebar visual state
              customRadioContainer.querySelectorAll('.custom-radio').forEach(radio => radio.classList.remove('selected'));
              customRadio.classList.add('selected');
              document.getElementById(`confirmButton-${index}`).disabled = false; // Enable the confirm button
            });
          });

          sidebarContent.appendChild(customRadioContainer);

          // Create the Confirm button
          const confirmButton = document.createElement('button');
          confirmButton.classList.add('confirm-button');
          confirmButton.textContent = 'Confirm Selection';
          confirmButton.setAttribute('id', `confirmButton-${index}`);
          confirmButton.disabled = true;

          confirmButton.addEventListener('click', () => {
            const selectedVariant = variantSidebar.querySelector('.custom-radio.selected input').value;
            if (selectedVariant) {
              // Reload the page after confirming selection
              window.location.reload(); // Reload the page to reset everything

              // Optionally, you can close the sidebar and hide the overlay
              slideOutSidebar(variantSidebar); // Slide the sidebar out of view
              overlay.style.display = 'none'; // Hide the overlay
            }
          });

          sidebarContent.appendChild(confirmButton);

          // after creating the Confirm button, add this:
          const closeButton = document.createElement('button');
          closeButton.classList.add('close-button');
          closeButton.textContent = '×';
          
          closeButton.addEventListener('click', () => {
            // Clear all selected states
            customRadioContainer.querySelectorAll('.custom-radio').forEach(radio => radio.classList.remove('selected'));
            sidebarContent.querySelectorAll('input[type="radio"]').forEach(input => (input.checked = false));
            document.getElementById(`confirmButton-${index}`).disabled = true; // Disable the confirm button
          
            // Close the sidebar
            slideOutSidebar(variantSidebar);
            overlay.style.display = 'none'; // Hide the overlay
          });
          
          // Add the close button to the sidebar
          variantSidebar.appendChild(closeButton);
          
          // Style the close button
          closeButton.style.position = 'absolute';
          closeButton.style.color = '#FF2675';
          closeButton.style.top = '10px';
          closeButton.style.right = '10px';
          closeButton.style.backgroundColor = 'transparent';
          closeButton.style.border = 'none';
          closeButton.style.fontSize = '30px';
          closeButton.style.cursor = 'pointer';
        })
        
        .catch(error => console.error('Error fetching product data:', error));

      // Add the sidebar to the DOM
      document.body.appendChild(variantSidebar);

      // Show Sidebar and Overlay when component is clicked
      component.addEventListener('click', () => {
        slideInSidebar(variantSidebar); // Slide the sidebar in
        overlay.style.display = 'block'; // Show the overlay
      });
    });

    // Close sidebar when overlay is clicked
    overlay.addEventListener('click', () => {
      document.querySelectorAll('.variant-sidebar').forEach(sidebar => {
        slideOutSidebar(sidebar); // Slide the sidebar out
      });
      overlay.style.display = 'none'; // Hide the overlay
    });

    // Inserted script to handle image visibility based on data-variant-selected attribute
    const gridItems = document.querySelectorAll('.bundly__component_grid_item');

    gridItems.forEach(function(item) {
      // Get the value of the `data-variant-selected` attribute
      const isVariantSelected = item.getAttribute('data-variant-selected') === 'true';

      // Get the image container
      const imageContainer = item.querySelector('.bundly__component_image');

      if (imageContainer) {
        // If data-variant-selected is 'true', show the image container
        if (isVariantSelected) {
          imageContainer.style.display = 'block'; // or use 'flex' if needed
        } else {
          imageContainer.style.display = 'none';
        }
      }
    });


    }, 700); //settimeout 3000 milliseconds = 3 seconds
    
  }); //domloaded







  // Function to slide the sidebar in from the right
  function slideInSidebar(sidebar) {
    sidebar.style.display = 'block';
    sidebar.style.transition = 'transform 0.3s ease';
    sidebar.style.transform = 'translateX(0)';
  }

  // Function to slide the sidebar out to the right
  function slideOutSidebar(sidebar) {
    sidebar.style.transition = 'transform 0.3s ease';
    sidebar.style.transform = 'translateX(100%)';
  }






  // MAIN PAGE SHOW ONLY CHOSEN
  document.addEventListener('DOMContentLoaded', function() {
    const variantGroups = document.querySelectorAll('.bundly__product_option');

    variantGroups.forEach(group => {
      const radios = group.querySelectorAll('.bundly__variant_radio');

      // Function to update display based on the checked state
      const updateDisplay = () => {
        radios.forEach(radio => {
          // Show only the selected option in each group
          if (radio.checked) {
            radio.parentElement.style.display = 'block';
          } else {
            radio.parentElement.style.display = 'none';
          }
        });
      };

      // Set initial display on page load
      updateDisplay();

      // Update display when any radio button in the group changes
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          updateDisplay();
        });
      });
    });
  }); 

